import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiJobsJobIdErrorsRequestExportCacheKeys: AllRouteEndpoints[] = [];
